import { render, staticRenderFns } from "./FilterOrientations.vue?vue&type=template&id=63207ae7&"
import script from "./FilterOrientations.vue?vue&type=script&lang=js&"
export * from "./FilterOrientations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports